import React from "react";
import {observer} from "mobx-react";
import {IonMenu} from "@ionic/react";
import {useServices} from "../../../../hooks/use-services.hook";
import styled from "styled-components";
import {HybridPageSideMenuContentComponent} from "./hybrid-page-side-menu-content.component";
import {HybridPageSideMenuHeaderComponent} from "./hybrid-page-side-menu-header.component";
import {HybridPageSideMenuFooterComponent} from "./hybrid-page-side-menu-footer.component";

const IonMenuBox = styled(IonMenu)`

    ${props => props.theme.screenMediaQuery.xsAndBelow} {
        width: 100vw;
        &::part(container) {
            width: 100vw;
        }    
    }
`

export const HybridPageSideMenuComponent: React.FC = observer(() => {
    const services = useServices();
    if(services.layout.shouldUseWebappLayout) {
        return null;
    }

    const sideMenuController = services.sideMenu.hybridMainSideMenuController;

    return (
        <IonMenuBox menuId={sideMenuController.menuId} contentId={sideMenuController.contentId} side={"end"}>
            <HybridPageSideMenuHeaderComponent/>
            <HybridPageSideMenuContentComponent/>
            <HybridPageSideMenuFooterComponent/>

        </IonMenuBox>
    );
})